/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/fileGWClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/fileGWClient'
import type {
  FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryResponse,
  FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryParams,
  FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetHeaderParams,
  FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGet422,
} from '../../types/FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGet.ts'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const foUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryKey = (
  params?: FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryParams,
) => [{ url: '/api/v1/user_folder/file_object/storage_info' }, ...(params ? [params] : [])] as const

export type FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryKey = ReturnType<
  typeof foUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryKey
>

/**
 * @summary Fo User Storage Info
 * {@link /api/v1/user_folder/file_object/storage_info}
 */
export async function foUserStorageInfoApiV1UserFolderFileObjectStorageInfoGet(
  params?: FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryParams,
  headers?: FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryResponse,
    ResponseErrorConfig<FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGet422>,
    unknown
  >({ method: 'GET', url: `/api/v1/user_folder/file_object/storage_info`, params, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

export function foUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryOptions(
  params?: FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryParams,
  headers?: FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = foUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryKey(params)
  return queryOptions<
    FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryResponse,
    ResponseErrorConfig<FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGet422>,
    FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return foUserStorageInfoApiV1UserFolderFileObjectStorageInfoGet(params, headers, config)
    },
  })
}

/**
 * @summary Fo User Storage Info
 * {@link /api/v1/user_folder/file_object/storage_info}
 */
export function useFoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGet<
  TData = FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryResponse,
  TQueryData = FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryResponse,
  TQueryKey extends QueryKey = FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryKey,
>(
  params?: FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryParams,
  headers?: FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetHeaderParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryResponse,
        ResponseErrorConfig<FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGet422>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? foUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryKey(params)

  const query = useQuery(
    {
      ...foUserStorageInfoApiV1UserFolderFileObjectStorageInfoGetQueryOptions(params, headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<FoUserStorageInfoApiV1UserFolderFileObjectStorageInfoGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}